import React from "react";

const year = new Date().getFullYear();

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-container">
        <div className="location">
          <i class="fa-solid fa-house"></i>
          <p>Beirut, Lebanon</p>
        </div>
        <div className="phone">
          <i class="fa-solid fa-phone"></i>
          <p>71-670716</p>
        </div>
        <div className="email">
          <i class="fa-solid fa-envelopes-bulk"></i>
          <p>info@gmail.com</p>
        </div>
        <div className="icons">
          <i class="fa-brands fa-github"></i>
          <i class="fa-brands fa-linkedin"></i>
          <i class="fa-brands fa-facebook"></i>
        </div>
        <h4 className="copyright">
          Copyright {year} Charbel_A_K. All rights reserved.
        </h4>
      </div>
    </div>
  );
};

export default Footer;
